// libs
import { connect } from 'react-redux';

// component
import WidgetLoader from './WidgetLoader';

// redux selectors
import {
  getWidgetData,
  isWidgetFetching,
  getProductIDFromWidgetStore,
  widgetError,
} from 'shared/store/widgets/selectors';
import { getProductId } from 'shared/store/details/selectors';
import { getStoreId } from 'shared/store/app/selectors';

// redux actions
import { fetchWidgetData } from 'shared/store/widgets/services';

// def
import { IWidgetLoaderProps } from './WidgetLoader';

const mapStateToProps = (state: any, ownProps: IWidgetLoaderProps) => {
  const { isMobile = false } = ownProps;

  return {
    widgetData: getWidgetData(state),
    isWidgetFetching: isWidgetFetching(state),
    productIDFromWidgetStore: getProductIDFromWidgetStore(state),
    productID: getProductId(state),
    isFailed: widgetError(state),
    isMobile,
    storeId: getStoreId(state),
  };
};

const mapActionToDispatch = {
  fetchWidgetData,
};

export default connect(mapStateToProps, mapActionToDispatch)(WidgetLoader);
